export const errorMessages = {
  requiredMessage: "This field is required.",
  numeric: "This field should contains only numbers",
  toastErrorDetail: "The form has errors that need to be corrected.",
  toastErrorSummary: "Error Message",
  toastErrorLife: 3000,
  number: "The value must be > 0",
  servicesTreatment1_4: "Must select at least one.",
  servicesDetoxificationOnly: "Must select only one.",
  servicesDetoxificationOnlyAtLeast: "Must select at least one.",
  demographicsHispanicLatino: "Must select at least one.",
  demographicsRace: "Must select at least one.",
  demographicsBirthDate: "Must select at least one.",
  educationReceiveMoney: "Must select at least one.",
  educationInvalidAmount: "Invalid value. Check point 3.",
  servicesReceived_1: "Must select at least one.",
  illegalDrugs: "The value B.1.c must be grater than 0",
  injectionDrugs: "This value must be Yes. Check route values B.2.a to B.2.i",
  pdfError: "Can not get pdf report",
  genericError: "Something went wrong",
  thinkOfYourself: "Must select at least one.",
  relationshipStatus: "Must select at least one.",
  daysGreaterThanZero: "Days must be > 0.",
  mentalHealthIlness:
    "No mental health illness selected. Please select this field",
  enoughMoneyExpenses: "Must select at least one.",
  mustSelectAtLeastOne: "Must select at least one.",
}
